import type { CheckoutSession } from "@/types";
import { encodeCurrency } from "@/lib/codec";

import { getTracker } from "./analytics-helpers";

/**
 * Fires once when Single Page Checkout renders.
 * PRD: the only new event for this feature; funnel is SinglePageCheckoutShown -> Authorized.
 */
export function emitSinglePageCheckoutShownTracking(
  session: CheckoutSession,
): void {
  const tracker = getTracker();
  if (
    !tracker ||
    !session.merchant?.id ||
    !session.id ||
    !session.order?.id ||
    !session.customerId ||
    !session.order?.countryCode
  ) {
    return;
  }

  const currencyCode = encodeCurrency(session.order.currency) ?? "SAR";
  const selectedOption = session.paymentOptions?.find(
    (o) => o.offerId === session.selectedPaymentOptionId,
  );

  tracker.track({
    eventType: "single_page_checkout_shown",
    merchantId: session.merchant.id,
    checkoutId: session.id,
    orderId: session.order.id,
    customerId: session.customerId,
    countryCode: session.order.countryCode,
    currencyCode,
    eventData: {
      offerId: session.selectedPaymentOptionId,
      instalments: session.installments,
      productType: selectedOption?.productType ?? null,
      paymentType: session.paymentType,
    },
  });
}
